module.exports = __webpack_public_path__ + "img/createVideo.6e97d1e6.png";